import React, { useState, useMemo, useRef } from 'react'
import FormatText from '../../Hub/Org/Handbook/components/FormatText'
import { Okpd2 } from '../../Hub/Org/Handbook/types'
import Okpd2Item from './components/Okpd2Item'
import Okpd2ItemSearch from './components/Okpd2ItemSearch'
import LoadingIcon from '../../../components/LoadingIcon'
import useDebounce from '../../../hooks/useDebounce'
import useFetch from '../../../hooks/useFetch'
import { Link } from 'react-router-dom'

import HoverTooltip from '../../../components/HoverTooltip'

import MagicStick from '../../Hub/Plans/Positions/Edit/components/MagicStick'

import './Robot.css' // подключим CSS отдельно

const Okpd2Page: React.FC = () => {
    const [isFiltering, setIsFiltering] = useState(true)

    const [query, setQuery] = useState('')
    const [queryTextAI, setQueryTextAI] = useState('')
    const [queryAI, setQueryAI] = useState('')

    const debouncedQuery = useDebounce(
        query != '' ? query : queryAI != '' ? queryAI : '',
        500
    )

    const apiUrl = debouncedQuery
        ? queryAI
            ? `https://itzakupki.ru/api/backend/v1/public/okpd2/predict?text_query=${encodeURIComponent(debouncedQuery)}`
            : /^[0-9]/.test(debouncedQuery[0])
              ? `https://itzakupki.ru/api/backend/v1/public/okpd2/search_code?text_query=${encodeURIComponent(debouncedQuery)}`
              : `https://itzakupki.ru/api/backend/v1/public/okpd2/search_name?text_query=${encodeURIComponent(debouncedQuery)}`
        : `https://itzakupki.ru/api/backend/v1/public/okpd2/code`

    // Опции для fetch, мемоизированные с помощью useMemo
    const fetchOptions: RequestInit = useMemo(
        () => ({
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        }),
        []
    ) // зависимости пустые, объект будет создан один раз

    const { data, loading, error } = useFetch<Okpd2[]>(apiUrl, fetchOptions)

    const handlerFilter = () => {
        setIsFiltering(!isFiltering)
        setQuery('')
    }

    const handlerSearchClear = () => {
        setQuery('')
        setQueryTextAI('')
        setQueryAI('')
    }

    return (
        <div className="flex w-[1200px] h-full flex-col text-[#000000]">
            <div>
                Общероссийский классификатор продукции по видам экономической
                деятельности (ОКПД 2)
                <br />
                <span className="text-[12px] text-[#8A8A8A]">
                    Обращаем внимание, что источником данных для справочника
                    ОКПД2 является ЕИС. В связи с этим возможны незначительные
                    отличия от актуальных нормативных актов.
                </span>
            </div>
            <div className="flex flex-1 w-full justify-center h-full p-5">
                <div className="flex flex-col w-full h-full space-y-10">
                    {/* // body */}
                    <div className="flex w-full h-full">
                        {/* table */}
                        <div className="flex flex-col h-full w-full">
                            {/* toolbar */}
                            <div className="flex flex-row gap-1 text-[#FFFFFF] p-2 bg-[#d9dce0] rounded-t-lg items-center">
                                {/* Filter */}
                                <HoverTooltip
                                    tooltipText={
                                        isFiltering
                                            ? 'Убрать фильтр'
                                            : 'Показать фильтр'
                                    }
                                >
                                    <button
                                        className="w-6 h-6 grid rounded-full place-items-center hover:bg-[#FFFFFF]"
                                        onClick={handlerFilter}
                                    >
                                        {isFiltering ? (
                                            <svg
                                                className="w-3 h-3"
                                                xmlns="http://www.w3.org/2000/svg"
                                                data-name="Layer 1"
                                                viewBox="0 0 24 24"
                                                id="filter-slash"
                                            >
                                                <path
                                                    id="svg_1"
                                                    d="m19,2l-14,0a3,3 0 0 0 -3,3l0,1.17a3,3 0 0 0 0.25,1.2l0,0.06a2.81,2.81 0 0 0 0.59,0.86l6.16,6.12l0,6.59a1,1 0 0 0 0.47,0.85a1,1 0 0 0 0.53,0.15a1,1 0 0 0 0.45,-0.11l4,-2a1,1 0 0 0 0.55,-0.89l0,-4.59l6.12,-6.12a2.81,2.81 0 0 0 0.59,-0.86l0,-0.06a3,3 0 0 0 0.29,-1.2l0,-1.17a3,3 0 0 0 -3,-3zm-5.71,11.29a1,1 0 0 0 -0.29,0.71l0,4.38l-2,1l0,-5.38a1,1 0 0 0 -0.29,-0.71l-5.3,-5.29l13.18,0l-5.3,5.29zm6.71,-7.29l-16,0l0,-1a1,1 0 0 1 1,-1l14,0a1,1 0 0 1 1,1l0,1z"
                                                    fill="#616173"
                                                />
                                                <path
                                                    id="svg_2"
                                                    d="m10.35653,-2.20952c0,-0.54338 0.45662,-1 1,-1l0.14286,0c0.54338,0 1,0.45662 1,1l0,25.07412c0,0.54338 -0.45662,1 -1,1l-0.14286,0c-0.54338,0 -1,-0.45662 -1,-1l0,-25.07412z"
                                                    transform="rotate(-43.639, 11.428, 10.3275)"
                                                    opacity="undefined"
                                                    fill="#ff0000"
                                                />
                                            </svg>
                                        ) : (
                                            <svg
                                                className="w-3 h-3"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                id="filter"
                                            >
                                                <path
                                                    fill="#616173"
                                                    d="M19,2H5A3,3,0,0,0,2,5V6.17a3,3,0,0,0,.25,1.2l0,.06a2.81,2.81,0,0,0,.59.86L9,14.41V21a1,1,0,0,0,.47.85A1,1,0,0,0,10,22a1,1,0,0,0,.45-.11l4-2A1,1,0,0,0,15,19V14.41l6.12-6.12a2.81,2.81,0,0,0,.59-.86l0-.06A3,3,0,0,0,22,6.17V5A3,3,0,0,0,19,2ZM13.29,13.29A1,1,0,0,0,13,14v4.38l-2,1V14a1,1,0,0,0-.29-.71L5.41,8H18.59ZM20,6H4V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z"
                                                ></path>
                                            </svg>
                                        )}
                                    </button>
                                </HoverTooltip>
                            </div>

                            {/* name */}
                            <div className="flex flex-row gap-1 h-12 bg-[#e4e7ea] text-[#616173] text-[10px] p-1">
                                <div className="flex flex-col w-8 justify-center items-center text-center"></div>
                                <div className="flex flex-col w-16 justify-center items-center text-center">
                                    Код
                                </div>
                                <div className="flex flex-1 items-center justify-center text-center">
                                    Наименование и описание
                                </div>
                                <div className="flex flex-row w-fit items-center justify-end text-left px-2 py-2 gap-1 ">
                                    {/* <HoverTooltip
                                        tooltipText="Доступно только для
                                                    зарегистрированных
                                                    пользователей"
                                        align="center"
                                    >
                                        <Link to={'/price'}>
                                            <div className="relative flex w-24 text-center justify-center items-center pl-1 py-1 rounded-md bg-[#d9dce0] hover:bg-[#e3e5e9] border border-[#8A8A8A] cursor-pointer">
                                                Закупка <br /> МСП
                                            </div>
                                        </Link>
                                    </HoverTooltip> */}
                                    <div className="flex w-24 text-center justify-center items-center pl-1 ">
                                        Нацрежим <br /> (запрет)
                                    </div>
                                    <div className="flex w-24 text-center justify-center items-center pl-1 ">
                                        Нацрежим <br /> (ограничение)
                                    </div>
                                    <div className="flex w-24 text-center justify-center items-center pl-1 ">
                                        Минимальная доля товаров из РФ
                                    </div>
                                    <div className="flex w-24 text-center justify-center items-center pl-1 ">
                                        В электронной форме
                                    </div>
                                </div>
                                <div className="flex flex-col w-2 justify-center items-center text-center"></div>
                            </div>

                            {/* filter */}
                            {isFiltering ? (
                                <div className="flex flex-row gap-1 h-fit text-[#6A6A6A] bg-[#e4e7ea] text-[10px] p-1 pl-2 items-end justify-left">
                                    <div className="flex w-9 h-7 items-center justify-center text-center">
                                        {loading && (
                                            <div className="flex items-center justify-center text-center text-[#6A6A6A]">
                                                <svg
                                                    className="animate-spin h-4 w-4 text-[#181818]"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle
                                                        className="opacity-25"
                                                        cx="12"
                                                        cy="12"
                                                        r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"
                                                    ></circle>
                                                    <path
                                                        className="opacity-75"
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                                    ></path>
                                                </svg>
                                            </div>
                                        )}
                                    </div>
                                    <div className="flex flex-col w-full mr-2 gap-1">
                                        <label className="text-[12.8px] text-[#6A6A6A] text-left">
                                            Обычный поиск
                                        </label>
                                        <input
                                            className="flex flex-row flex-1 px-2 py-1 h-[28px] rounded-md text-sm text-[#181818] bg-[#FFFFFF] focus:outline-none focus:ring-1 focus:ring-[#181818]"
                                            value={query}
                                            onChange={(e) => {
                                                setQuery(
                                                    e.target.value.replace(
                                                        ',',
                                                        '.'
                                                    )
                                                )
                                                setQueryTextAI('')
                                                setQueryAI('')
                                            }}
                                            placeholder="Введите код или наименование"
                                            disabled={queryAI != '' && loading}
                                        />
                                    </div>

                                    <div className="flex flex-col w-full mr-2 gap-1">
                                        <label className="text-[12.8px] text-[#6A6A6A] text-left">
                                            Поиск с использованием нейросети
                                        </label>
                                        <div className="flex flex-row w-full items-center justify-left gap-1">
                                            {queryTextAI && (
                                                <HoverTooltip tooltipText="Мне повезет!">
                                                    <div
                                                        className={`flex w-6 h-6 items-center justify-center rounded-full ${loading ? '' : 'hover:bg-[#FFFFFF] cursor-pointer'}`}
                                                        onClick={() => {
                                                            setQuery('')
                                                            setQueryAI(
                                                                queryTextAI
                                                                    ? queryTextAI
                                                                    : ''
                                                            )
                                                        }}
                                                    >
                                                        <MagicStick />
                                                    </div>
                                                </HoverTooltip>
                                            )}

                                            <input
                                                className="flex flex-row flex-1 px-2 py-1 h-[28px] rounded-md text-sm text-[#181818] bg-[#FFFFFF] focus:outline-none focus:ring-1 focus:ring-[#181818]"
                                                value={queryTextAI}
                                                onChange={(e) => {
                                                    setQuery('')
                                                    setQueryTextAI(
                                                        e.target.value.replace(
                                                            ',',
                                                            '.'
                                                        )
                                                    )
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setQuery('')
                                                        setQueryAI(
                                                            queryTextAI
                                                                ? queryTextAI
                                                                : ''
                                                        )
                                                    }
                                                }}
                                                placeholder="Введите наименование"
                                                disabled={
                                                    queryAI != '' && loading
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className="flex w-9 h-7 items-center justify-center text-center">
                                        <HoverTooltip
                                            tooltipText="Очистить фильтр"
                                            align="left"
                                        >
                                            <button
                                                className="flex w-6 h-6 rounded-full items-center justify-center hover:bg-[#FFFFFF]"
                                                onClick={handlerSearchClear}
                                            >
                                                <svg
                                                    className="w-3 h-3"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    data-name="Layer 1"
                                                    viewBox="0 0 24 24"
                                                    id="x"
                                                >
                                                    <path
                                                        fill="#181818"
                                                        d="M8 19a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3 1 1 0 0 0 0-2 5 5 0 0 0-5 5v8a5 5 0 0 0 5 5 1 1 0 0 0 0-2Zm7.71-3.29a1 1 0 0 0 0-1.42L13.41 12l2.3-2.29a1 1 0 0 0-1.42-1.42L12 10.59l-2.29-2.3a1 1 0 0 0-1.42 1.42l2.3 2.29-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.29-2.3 2.29 2.3a1 1 0 0 0 1.42 0ZM16 3a1 1 0 0 0 0 2 3 3 0 0 1 3 3v8a3 3 0 0 1-3 3 1 1 0 0 0 0 2 5 5 0 0 0 5-5V8a5 5 0 0 0-5-5Z"
                                                    ></path>
                                                </svg>
                                            </button>
                                        </HoverTooltip>
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}

                            {/* data */}
                            <div className="flex flex-col gap-1 py-1 h-full bg-[#e4e7ea33] rounded-b-md max-h-[calc(100vh_-_300px)] overflow-y-auto custom-scrollbar">
                                {/* Вывод списка ОКПД2 */}
                                {error && (
                                    <p className="text-[#181818] dark:text-[#FFFFFF] p-2">
                                        Ошибка: "{error.message}"
                                    </p>
                                )}
                                {loading ? (
                                    queryAI ? (
                                        <div className="flex w-full h-full py-5 items-center justify-center opacity-85">
                                            <svg
                                                width="120"
                                                height="120"
                                                viewBox="0 0 120 120"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g
                                                    id="robot"
                                                    transform="translate(60,60)"
                                                >
                                                    <g
                                                        id="head"
                                                        className="robot-head"
                                                    >
                                                        {/* голова */}
                                                        <rect
                                                            x="-20"
                                                            y="-20"
                                                            width="40"
                                                            height="30"
                                                            rx="4"
                                                            ry="4"
                                                            stroke="#181818"
                                                            strokeWidth="2"
                                                            fill="none"
                                                        />
                                                        {/* глаз левый */}
                                                        <circle
                                                            cx="-10"
                                                            cy="-10"
                                                            r="4"
                                                            fill="#181818"
                                                        />
                                                        {/* глаз правый */}
                                                        <circle
                                                            cx="10"
                                                            cy="-10"
                                                            r="4"
                                                            fill="#181818"
                                                        />
                                                        {/* рот */}
                                                        <path
                                                            d="M -16,0 Q 0,8 16,0"
                                                            stroke="#00C6CF"
                                                            strokeWidth="2"
                                                            fill="none"
                                                        />
                                                        {/* антенна */}
                                                        <line
                                                            x1="0"
                                                            y1="-25"
                                                            x2="0"
                                                            y2="-20"
                                                            stroke="#181818"
                                                            strokeWidth="5"
                                                        />
                                                        {/* волна */}
                                                        <path
                                                            d="M -6,-30 Q 0,-34 6,-30"
                                                            stroke="#00C6CF"
                                                            strokeWidth="2"
                                                            fill="none"
                                                        />
                                                        {/* ухо левое */}
                                                        <rect
                                                            x="-28"
                                                            y="-10"
                                                            width="6"
                                                            height="10"
                                                            rx="2"
                                                            fill="#00C6CF"
                                                        />
                                                        {/* ухо правое */}
                                                        <rect
                                                            x="22"
                                                            y="-10"
                                                            width="6"
                                                            height="10"
                                                            rx="2"
                                                            fill="#00C6CF"
                                                        />
                                                    </g>
                                                    {/* шея */}
                                                    <g id="neck">
                                                        <rect
                                                            x="-5"
                                                            y="10"
                                                            width="10"
                                                            height="10"
                                                            fill="#181818"
                                                        />
                                                    </g>
                                                    {/* торс */}
                                                    <g id="base">
                                                        <rect
                                                            x="-30"
                                                            y="20"
                                                            width="60"
                                                            height="10"
                                                            rx="3"
                                                            stroke="#181818"
                                                            strokeWidth="2"
                                                            fill="none"
                                                        />
                                                    </g>
                                                </g>
                                            </svg>
                                        </div>
                                    ) : (
                                        <div className="flex w-full h-full py-5 items-center justify-center">
                                            <svg
                                                className="animate-spin h-10 w-10 text-[#FFFFFF]"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <circle
                                                    className="opacity-25"
                                                    cx="12"
                                                    cy="12"
                                                    r="10"
                                                    stroke="#181818"
                                                    strokeWidth="4"
                                                ></circle>
                                                <path
                                                    className="opacity-75"
                                                    fill="#181818"
                                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                                ></path>
                                            </svg>
                                        </div>
                                    )
                                ) : (
                                    data &&
                                    (data.length > 0 ? (
                                        data.map((item) =>
                                            query == '' ? (
                                                <Okpd2Item
                                                    key={item.guid}
                                                    item={item}
                                                    level={0}
                                                />
                                            ) : (
                                                <Okpd2ItemSearch
                                                    key={item.guid}
                                                    item={item}
                                                />
                                            )
                                        )
                                    ) : (
                                        <div className="flex w-full h-full items-center justify-center">
                                            Ничего не найдено
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Okpd2Page
